//Would be cool to use Legacy LSHelper.Sso instead, but it's part of entire LSHelper :(
export function popupSsoLoginCommon(url: string, setRememberMe?: boolean, width?: number, height?: number) {
   width = (width == undefined ? 700 : width);
   height = (height == undefined ? 700 : height);
   let left = (screen.width - width) / 2;
   let top = (screen.height - height) / 2;
   let params = "width=" + width + ", height=" + height;
   params += ", top=" + top + ", left=" + left;
   params += ", directories=no";
   params += ", location=no";
   params += ", menubar=no";
   params += ", resizable=yes";
   params += ", scrollbars=yes";
   params += ", status=no";
   params += ", toolbar=no";
   if (setRememberMe) {
      let rememberMeElement = <HTMLInputElement>document.getElementById("RememberMe");
      if (rememberMeElement)
         url = url + "&rememberMe=" + rememberMeElement.checked;
   }
   let newwin = window.open(url, "ssoLoginWindow", params);
   if (window.focus as any) {
      if (newwin)
         newwin.focus();
   }
   return newwin;
}
